import { getAuthHeader } from './auth';

const BASE_URL = process.env.REACT_APP_DHIS2_BASE_URL || '';

/**
 * Finds the Level 5 parent organization unit using direct API calls
 */
export async function findLevel5ParentOrgUnit(orgUnitId, authOverride) {
  try {
    // Fetch the org unit with ancestors
    const response = await fetch(
      `${BASE_URL}/api/organisationUnits/${orgUnitId}?fields=id,name,level,ancestors[id,name,level]`,
      { headers: getAuthHeader(authOverride) }
    );
    
    if (!response.ok) {
      throw new Error(`Failed to fetch org unit ${orgUnitId}`);
    }
    
    const orgUnitData = await response.json();
    
    // Find the Level 5 ancestor
    const level5Ancestor = orgUnitData.ancestors?.find(ancestor => 
      ancestor.level === 5
    );
    
    if (level5Ancestor) {
      console.log(`Found Level 5 parent for ${orgUnitData.name}: ${level5Ancestor.name}`);
      return level5Ancestor;
    }
    
    // If no Level 5 found, check if the current org unit is Level 5
    if (orgUnitData.level === 5) {
      console.log(`Org unit ${orgUnitData.name} is already Level 5`);
      return { id: orgUnitData.id, name: orgUnitData.name };
    }
    
    // Fallback: return the main org unit
    console.warn(`No Level 5 parent found for ${orgUnitData.name}, using original org unit`);
    return { id: orgUnitData.id, name: orgUnitData.name };
    
  } catch (error) {
    console.error(`Error finding Level 5 parent for org unit ${orgUnitId}:`, error);
    // Fallback: return the original org unit ID
    return { id: orgUnitId, name: 'Unknown' };
  }
}

/**
 * Gets the level of an org unit
 */
export async function getOrgUnitLevel(orgUnitId, authOverride) {
  try {
    const response = await fetch(
      `${BASE_URL}/api/organisationUnits/${orgUnitId}?fields=level`,
      { headers: getAuthHeader(authOverride) }
    );
    
    if (!response.ok) {
      throw new Error(`Failed to fetch org unit level for ${orgUnitId}`);
    }
    
    const orgUnitData = await response.json();
    return orgUnitData.level;
  } catch (error) {
    console.error(`Error getting level for org unit ${orgUnitId}:`, error);
    return null;
  }
}